import React, { Component } from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';

import './App.css';

//---- Compoenents
import Header from './routes/header';
import Footer from './routes/footer';

//---- Pages
import HomePage from './routes/index';
import Restream from './routes/restream';
import EmojiCrew from './routes/emojicrew';
import Radio from './routes/radio';
import RadioSuite from './routes/radiosuite';
import Default from './routes/default';
//import Login from './routes/login';
import RadioInvite from './routes/radioinvite';

//---- Components
import {UserProvider} from './utils/usercontext';
import Socket from './utils/socket';

//---- CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import './routes/css/styles.css';
import './routes/css/velvet.css';
import './routes/css/boxicons.css';

export default class App extends Component {
  render() {
    return (
      <div style={{height: "100%"}}>
        <UserProvider>
          <BrowserRouter>
            <Header />
            <Routes>
              <Route path="/" exact element={<HomePage />} />
              <Route path="/restream" exact element={<Restream />} />
              <Route path="/emojicrew" exact element={<EmojiCrew />} />
              <Route path="/radio" exact element={<Radio />} />
              <Route path="/radiosuite" exact element={<RadioSuite />} />
              <Route path="/default" exact element={<Default />} />

              <Route path="/radio/:channel" exact element={<RadioInvite />} />
              <Route path="/radio/:channel/:code" exact element={<RadioInvite />} />
              {/*<Route path="/:id" element={<UltraStreamTemplate />} />*/}
            </Routes>
            <Footer />
            {/*<Socket />*/}
          </BrowserRouter>
        </UserProvider>
      </div>
    );
  }
};
